import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import commonFunction from '../../Utils/commonFunction';
import { useDispatch } from 'react-redux';
import { getWalletAmount } from '../../app/wallet/wallet.slice';


const Cancelorder = ({ isCancelOrderOpen, iscloseCancelOrder, id, orderData, setOrders, orderItem }) => {

    const dispatch = useDispatch();
    const [reasonType, setReasonType] = useState("");
    const [customReason, setCustomReason] = useState("");

    const childName = orderItem?.Child?.name || "";
    const handleClose = () => {
        setReasonType("");
        setCustomReason("");
        iscloseCancelOrder();
    };

    const REASONS = [
        { value: "Jeg har Ombestemt Mig", label: "Jeg har Ombestemt Mig" },
        { value: `${childName} er syg`, label: `${childName} er syg` },
        { value: `${childName} på Klassetur`, label: `${childName} på Klassetur` },
        { value: "other", label: "Andet" },
    ];

    const handleSubmit = async () => {
        // Validate reason
        const selectedReason = reasonType === "other" ? customReason.trim() : (REASONS.find(r => r.value === reasonType)?.label || "");
        if (!selectedReason) {
            toast.error("Vælg venligst eller indtast en grund for ændringen.");
            return;
        }

        await commonFunction.cancelOrder(id, selectedReason).then(res => {
            if (res.data.status === true) {
                toast.success(res.data.message);
                const getOrders = commonFunction.getOrders(orderData);
                getOrders.then((res) => {
                    setOrders(res.data);
                    handleClose();
                })

            } else {
                toast.info(res.data.message);
                iscloseCancelOrder();
            }
            dispatch(getWalletAmount());
        }).catch(err => {
            toast.error('something went wrong');
        })
    };

    return (
        <Dialog open={isCancelOrderOpen} onClose={handleClose}>
            <DialogTitle>Annuller din Bestilling</DialogTitle>
            <DialogContent>
                <div>
                    <p>Er du sikker på at annullere bestilling af denne <strong>{orderItem?.OrdersItems[0]?.itemName}</strong> ved leveringsdato <strong>{orderItem?.deliveryDate}</strong> for barn <strong>{orderItem?.Child.name}</strong> ?</p>

                    <div style={{ marginTop: 12 }}>
                        <label style={{ display: 'block', marginBottom: 6 }}>Vælg årsag til annullering</label>
                        <select
                            value={reasonType}
                            onChange={(e) => setReasonType(e.target.value)}
                            style={{ width: '100%', padding: 8 }}
                        >
                            <option value="">-- Vælg en årsag --</option>
                            {REASONS.map((r) => (
                                <option key={r.value} value={r.value}>{r.label}</option>
                            ))}
                        </select>
                    </div>

                    {reasonType === 'other' && (
                        <div style={{ marginTop: 12 }}>
                            <label style={{ display: 'block', marginBottom: 6 }}>Andet - beskriv venligst</label>
                            <textarea
                                value={customReason}
                                onChange={(e) => setCustomReason(e.target.value)}
                                rows={4}
                                style={{ width: '100%', padding: 8 }}
                                placeholder="Skriv din årsag her..."
                            />
                        </div>
                    )}

                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Annullere
                </Button>
                <Button onClick={handleSubmit} color="primary">
                    Bekræft
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default Cancelorder;
